var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#039BE5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.21 91.29-74 .41s-1-6.45 4.75-6.5c5.75-.05 18-1.24 20.77-2.82 1.94-1.11 2.41-10.06 2.51-15.33a28.33 28.33 0 0 1-3.6-3.9 43 43 0 0 1-6.47-12.38c-.61.33-1.33.41-2 .25-1.22-.39-1.12-1.65-2.48-5.21-1.55-4.07-1.52-7 .24-8.33a3.4 3.4 0 0 1 2-.59c.02-3.32.65-6.6 1.85-9.7 3.17-8 10.82-14.39 19.47-14.24 8.34.15 15.73 6.39 18.82 14.24a27.79 27.79 0 0 1 1.8 9.7c.75-.05 1.5.15 2.12.59 1.77 1.28 1.8 4.26.24 8.33-1.35 3.56-1.25 4.82-2.47 5.21a3 3 0 0 1-2.18-.31 39.72 39.72 0 0 1-9.44 15.67c.1 5.24.54 14.47 2.52 15.59 2.77 1.58 15 2.77 20.77 2.82 5.77.05 4.78 6.5 4.78 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 35.59V11.46a4 4 0 0 1 3.95-4h7.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.29 75.36h-7.84a4 4 0 0 1-3.95-4V43.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.49 43.89v27.53a4 4 0 0 1-3.95 4H79.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7 7.52h7.84a4 4 0 0 1 3.95 4v24.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 50.95a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.92 38.84v8.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92 42.95h8.19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 7h83.99v85.2H8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceId);
export default ForwardRef;